<div class="adf-page">
  <div class="adf-hero">
    <p class="adf-hero-text">
      Configure general action management settings for your project. Enable or disable core features that control how
      actions are processed and managed.
    </p>
  </div>

  <div class="adf-loader" *ngIf="!configurationLoaded">
    <app-ltms-loader></app-ltms-loader>
  </div>

  <div class="adf-settings" *ngIf="configurationLoaded">
    <form [formGroup]="generalForm" class="adf-settings-card">
      <div class="adf-setting-row">
        <div class="adf-setting-copy">
          <label class="adf-setting-label" for="enable-action-management">
            Enable Action Management
          </label>
          <p class="adf-setting-desc">
            Enable the core action management system for this project
          </p>
        </div>
        <label class="adf-switch">
          <input type="checkbox" id="enable-action-management"
            formControlName="is_action_workflow_enabled"
            (change)="onCheckboxChange('is_action_workflow_enabled', $any($event.target).checked)">
          <span class="adf-switch-slider"></span>
        </label>
      </div>

      <div class="adf-setting-row">
        <div class="adf-setting-copy">
          <label class="adf-setting-label" for="enable-attachments">
            Enable Attachments in Replies
          </label>
          <p class="adf-setting-desc">
            Allow users to attach files when replying to actions
          </p>
        </div>
        <label class="adf-switch">
          <input type="checkbox" id="enable-attachments"
            formControlName="feed_attachment_enabled"
            (change)="onCheckboxChange('feed_attachment_enabled', $any($event.target).checked)">
          <span class="adf-switch-slider"></span>
        </label>
      </div>

      <div class="adf-settings-footer">
        <button type="button" class="adf-btn adf-btn--ghost" (click)="cancelConfiguration()"
          [disabled]="!isSaveEnabled || isCancelling || readonly">Cancel</button>
        <button type="button" class="adf-btn adf-btn--primary" (click)="saveConfiguration()"
          [disabled]="!isSaveEnabled || isSaving || readonly">Save</button>
      </div>
    </form>
  </div>
</div>
